import React from "react";

const WeeklySettle = () => {
  return <div>WeeklySettle</div>;
};

export default WeeklySettle;
